import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { useEffect } from "react";
import Nav from "@/components/Nav";
import Footer from "@/components/Footer";
import Analytics from "@/components/Analytics";
import CookieNotice from "@/components/CookieNotice";
import Home from "@/pages/Home";
import Book from "@/pages/Book";
import About from "@/pages/About";
import Philosophy from "@/pages/Philosophy";
import System from "@/pages/System";
import BuildersCircle from "@/pages/BuildersCircle";
import Articles from "@/pages/Articles";
import Contact from "@/pages/Contact";
import Privacy from "@/pages/Privacy";
import Terms from "@/pages/Terms";
import AdminLogin from "@/pages/admin/AdminLogin";
import AdminDashboard from "@/pages/admin/AdminDashboard";
import AdminArticles from "@/pages/admin/AdminArticles";
import ReaderPreview from "@/pages/ReaderPreview";
import ThankYou from "@/pages/ThankYou";
import Checkout from "@/pages/Checkout";
import PaymentSuccess from "@/pages/PaymentSuccess";
import PaymentCancel from "@/pages/PaymentCancel";

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}

function SiteLayout({ children }) {
  return (
    <>
      <Nav />
      <main>{children}</main>
      <Footer />
    </>
  );
}

function App() {
  return (
    <div className="App bg-black min-h-screen">
      <BrowserRouter>
        <ScrollToTop />
        <Analytics />
        <Routes>
          {/* Admin — no marketing chrome */}
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route path="/admin" element={<AdminDashboard />} />
          <Route path="/admin/articles" element={<AdminArticles />} />

          {/* Public site */}
          <Route path="/" element={<SiteLayout><Home /></SiteLayout>} />
          <Route path="/book" element={<SiteLayout><Book /></SiteLayout>} />
          <Route path="/about" element={<SiteLayout><About /></SiteLayout>} />
          <Route path="/philosophy" element={<SiteLayout><Philosophy /></SiteLayout>} />
          <Route path="/system" element={<SiteLayout><System /></SiteLayout>} />
          <Route path="/builders-circle" element={<SiteLayout><BuildersCircle /></SiteLayout>} />
          <Route path="/articles" element={<SiteLayout><Articles /></SiteLayout>} />
          <Route path="/contact" element={<SiteLayout><Contact /></SiteLayout>} />
          <Route path="/preview" element={<SiteLayout><ReaderPreview /></SiteLayout>} />
          <Route path="/checkout" element={<SiteLayout><Checkout /></SiteLayout>} />
          <Route path="/payment/success" element={<SiteLayout><PaymentSuccess /></SiteLayout>} />
          <Route path="/payment/cancel" element={<SiteLayout><PaymentCancel /></SiteLayout>} />
          <Route path="/thank-you" element={<SiteLayout><ThankYou /></SiteLayout>} />
          <Route path="/privacy" element={<SiteLayout><Privacy /></SiteLayout>} />
          <Route path="/terms" element={<SiteLayout><Terms /></SiteLayout>} />
          <Route path="*" element={<SiteLayout><Home /></SiteLayout>} />
        </Routes>
        <CookieNotice />
      </BrowserRouter>
    </div>
  );
}

export default App;
